import { useRouteError } from "react-router-dom";
import { Container, Alert, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function ErrorFallback() {
  const error = useRouteError();
  const { t } = useTranslation();

  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "Unknown application error occurred";

  return (
    <Container
      fluid
      className="d-flex flex-column align-items-center justify-content-center min-vh-100 py-5 "
    >
      <Alert
        variant="light"
        className="shadow-lg p-4 rounded-3 w-100"
        style={{ maxWidth: "600px" }}
      >
        <Alert.Heading className="fs-3 fw-bold mb-3">
          {t("errorBoundary.Something went wrong")}
        </Alert.Heading>

        <p className="mb-4">
          {t(
            "errorBoundary.An unexpected error occurred. Please try to reload the page."
          )}
        </p>

        <pre
          className="bg-light p-3 rounded-3 text-break overflow-auto border border-danger border-opacity-25 text-danger-emphasis text"
          style={{ whiteSpace: "pre-wrap" }}
        >
          {message}
        </pre>

        <div className="d-grid mt-4">
          <Button
            variant="primary"
            size="lg"
            onClick={() => window.location.reload()}
          >
            {t("errorBoundary.Reload page")}
          </Button>
        </div>
      </Alert>
    </Container>
  );
}
